import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import PopupLoginError from "../Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";

function BoardForm({isMyBoard = false, formType = 'inquiry', boardList, member_seq }){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const isInquiry = formType === 'inquiry';
  const isSupport = formType === 'support'; // 제작지원 여부 체크
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // 마스킹 유틸
  const maskId = (id) => id.slice(0, 3) + '*'.repeat(id.length - 3);

  // 게시글 클릭 핸들러 수정
  const handleDetailPage = (item) => {

    // 제작지원인 경우 다른 방식으로 처리
    if (isSupport) {
      navigate(`/myPage/${formType}/${item.apply_seq}`);
      return;
    }

    if (isMyBoard) {
      // isMyBoard가 true일 때 = 커뮤니티인 경우
      if (member_seq === item.member_seq) {
        // 현재 로그인한 사용자의 ID와 게시글 작성자 ID가 같으면
        navigate(`/community/${formType}/detail/${item.b_seq}`);
        // 커뮤니티 상세보기로 이동 (/community/inquiry/123)
      } else {
        // 현재 로그인한 사용자의 ID와 게시글 작성자 ID가 다르면
        setIsPopupOpen(t("secret_post"));
        // 열람 불가 알림
      }
    } else {
      // isMyBoard가 false일 때 = 마이페이지인 경우
      if (item.member_seq) {
        // 현재 로그인한 사용자의 ID와 게시글 작성자 ID가 같으면
        navigate(`/myPage/${formType}/${item.b_seq}`);
        // 마이페이지 상세보기로 이동 (/myPage/inquiry/123)
      } else {
        // 현재 로그인한 사용자의 ID와 게시글 작성자 ID가 다르면
        setIsPopupOpen('비밀글입니다.');
        // 열람 불가 알림
      }
    }
  };

  // 제작지원과 일반 게시물의 데이터 구조가 다르므로 필드 매핑 함수 추가
  const getDisplayData = (item) => {
    if (isSupport) {
      return {
        id: item.apply_seq,
        title: item.work_title,
        date: item.regist_date,
        status: item.status,
        isAnswered: item.status === "답변완료"
      };
    }

    return {
      id: item.b_seq,
      title: item.subject,
      date: item.regist_date,
      boardType: item.board_type,
      userId: item.userid,
      isAnswered: item.answer_flag === "Y"
    };
  };

  return(
    <div>
      <ul>
        {boardList.map((item) => {
          const displayData = getDisplayData(item);

          return (
            <li
              key={isSupport ? item.apply_seq : item.b_seq}
              className="board_item"
              onClick={() => handleDetailPage(item)}
            >
              <div className="board_box flex-4 column">
                <h6 className="title flex-center-4 b1-2">
                  {/* 제작지원은 잠금 아이콘 필요 없음 */}
                  {!isSupport && member_seq !== item.member_seq && <i className="lock_icon" />}
                  <span className="ellipsis1" style={{whiteSpace: 'normal', width: '100%'}}>{displayData.title}</span>
                </h6>
                <div className="board_info board_line">
                  <span className="text_small g-70">{dayjs(displayData.date).format('YYYY.MM.DD HH:mm')}</span>
                  {isInquiry && !isSupport && (
                    <span className="text_small g-70">{displayData.boardType}</span>
                  )}
                  {isMyBoard && !isSupport && (
                    <span className="text_small g-70">{maskId(displayData.userId)}</span>
                  )}
                </div>
              </div>

              <div className="board_status">
                {displayData.isAnswered ? (
                  <span className="badge g-100">{t("inquiry_status_answered")}</span>
                ) : (
                  <span className="badge yellow">{t("inquiry_status_pending")}</span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      <PopupLoginError isPopup={isPopupOpen} setIsPopup={setIsPopupOpen}/>
    </div>
  );
}

export default BoardForm;
